import type { SpartacuxProductDiscoveryDomainState } from '../../productDiscovery.model';
import type { ProcessedRecommendationItem } from '../interfaces/msRecommendation';
import type { RecommendationPlaylist } from '../interfaces/productRecommendation';
import {
  selectProductRecommendationConfigs,
  selectProductRecommendations,
} from './productRecommendation';

// ENGINES

const similarityMLV2EngineName = 'SimilarityML_v2';

// SELECTOR

export const selectTopProductRecommendationsConfig = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): ProcessedRecommendationItem | undefined =>
  selectProductRecommendationConfigs(state)?.find(
    (reco) => reco.engineName && reco.engineName === similarityMLV2EngineName,
  );

export const selectTopProductRecommendations = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): RecommendationPlaylist | undefined =>
  selectProductRecommendations(state)?.find(
    (reco) => reco.engineName && reco.engineName === similarityMLV2EngineName,
  );
